import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Plateau } from "@/components/landing/Plateau";
import { Manifesto } from "@/components/landing/Manifesto";
import { Philosophy } from "@/components/landing/Philosophy";
import { Lifestyle } from "@/components/landing/Lifestyle";
import { Aspiration } from "@/components/landing/Aspiration";
import { Training } from "@/components/landing/Training";
import { Authority } from "@/components/landing/Authority";
import { Curriculum } from "@/components/landing/Curriculum";
import { Proof } from "@/components/landing/Proof";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";
import { StickyCTA } from "@/components/landing/StickyCTA";

export default function Landing() {
  useLenis();
  return (
    <div className="App grain relative">
      <div
        className="pointer-events-none fixed inset-0 z-[1] opacity-[0.06]"
        style={{ background: "radial-gradient(circle at 15% 0%, #d4af37, transparent 40%), radial-gradient(circle at 85% 100%, #d4af37, transparent 40%)" }}
      />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Plateau />
        <Manifesto />
        <Philosophy />
        <Lifestyle />
        <Aspiration />
        <Training />
        <Authority />
        <Curriculum />
        <Proof />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
}
